import React, { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import AllUsers from "./AllUsers";
import Pending from "./Pending";
// import filterIcon from "../../assets/images/filtericn.svg";
// import exportIcon from "../../assets/images/export.svg";
// import dropdownArrow from "../../assets/images/dropdown-arrow.svg";
// import pdf from "../../assets/images/pdf.svg";
// import printer from "../../assets/images/printer.svg";
// import csv from "../../assets/images/csv.svg";
import AddUserModal from "./modal/AddUserModal";
import { RoleRightsForModule } from "../../utils/utils";

const UserHeader = ({ searchValue, setSearchValue }) => {
  const [currentActiveTab, setCurrentActiveTab] = useState("allUsers");
  const [currentModal, setCurrentModal] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const toggleFunction = () => {
    setCurrentModal("");
  };

  const getCurrentRenderTab = () => {
    return [
      {
        tabId: "allUsers",
        tabName: "Users",
        Component: AllUsers,
      },
      {
        tabId: "pending",
        tabName: "Pending",
        Component: Pending,
      },
    ];
  };

  const currentRenderTab = getCurrentRenderTab();

  return (
    <>
      <div className="row align-items-center py-3">
        <div className="col-12 col-md-6 col-xl-6">
          <div className="user-tabs">
            <Nav tabs className="nav nav-tabs">
              {currentRenderTab?.map((d, index) => (
                <NavItem key={d.tabId} className="nav-item">
                  <NavLink
                    className={
                      currentActiveTab === d.tabId
                        ? "nav-link active"
                        : "nav-link"
                    }
                    //className="nav-link"
                    onClick={() => setCurrentActiveTab(d.tabId)}
                  >
                    {d.tabName}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            {/* <h5 className="intro-title" key={index}> {d.tabName}</h5> */}
          </div>
        </div>
        <div className="col-12 col-md-6 col-xl-6 mt-3 mt-md-0 text-start text-md-end">
          <div className="user-right-filter-grup">
            <div className="user-search-div me-3">
              <div className="intro-searchbar">
                <button type="submit" className="filter-search-btn"></button>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  value={searchValue}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                {searchValue.length > 0 && (
                  <button
                    type="button"
                    class="btn search-reset-btn"
                    onClick={() => setSearchValue("")}
                  >
                    <svg
                      class="close-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="13.414"
                      height="13.414"
                      viewBox="0 0 13.414 13.414"
                    >
                      <g
                        id="Group_31758"
                        data-name="Group 31758"
                        transform="translate(0.707 0.707)"
                      >
                        <path
                          id="Path_48155"
                          data-name="Path 48155"
                          d="M0,0,12,12"
                          fill="none"
                          stroke="#313b5c"
                          stroke-width="2"
                        ></path>
                        <path
                          id="Path_48154"
                          data-name="Path 48154"
                          d="M12,0,0,12"
                          fill="none"
                          stroke="#313b5c"
                          stroke-width="2"
                        ></path>
                      </g>
                    </svg>
                  </button>
                )}
              </div>
            </div>
            {RoleRightsForModule("Add", "Users") && (
              <button
                className="btn btn-primary-md btn-lg"
                onClick={() => setCurrentModal("addUserModal")}
              >
                + Add User
              </button>
            )}

            {/* <div className="dropdown action-dropdown me-2">
                            <button className="btn dropdown-toggle filter-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src={filterIcon} className="filter-btn-icn" alt="filtericn" />
                            </button>
                            <ul className="dropdown-menu">
                                <li><a className="dropdown-item active mb-1" href="#"> Filter by</a></li>
                                <li><a className="dropdown-item mb-1" href="#"> Group</a></li>
                                <li><a className="dropdown-item mb-1" href="#">Status</a></li>
                                <li><a className="dropdown-item mb-1" href="#">Role</a></li>
                            </ul>
                        </div> */}

            {/* <div className="dropdown export-dropdown">
                            <button className="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src={exportIcon} alt="" />  <span>Export</span> <img src={dropdownArrow} alt="" />
                            </button>
                            <ul className="dropdown-menu">
                                <li><a className="dropdown-item active" href="#"><span><img src={pdf} alt="" /></span> PDF</a></li>
                                <li><a className="dropdown-item" href="#"><span><img src={csv} alt="" /></span> CSV</a></li>
                                <li><a className="dropdown-item" href="#"><span><img src={printer} alt="" /></span> Print</a></li>
                            </ul>
                        </div> */}
          </div>
        </div>
      </div>
      <TabContent activeTab={currentActiveTab}>
        {currentRenderTab?.map((d) => {
          const { Component, tabId } = d;
          return (
            <TabPane key={tabId} tabId={tabId}>
              <div className="user-tabs-data-table">
                <div className="tab-content">
                  <Component
                    currentActiveTab={currentActiveTab}
                    searchValue={searchValue}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    perPage={perPage}
                    setPerPage={setPerPage}
                    setCurrentModal={setCurrentModal}
                    currentModal={currentModal}
                    setCurrentActiveTab={setCurrentActiveTab}
                  />
                </div>
              </div>
            </TabPane>
          );
        })}
      </TabContent>
      {currentModal === "addUserModal" && (
        <AddUserModal
          toggleFunction={toggleFunction}
          isVisible={currentModal === "addUserModal"}
          setCurrentActiveTab={setCurrentActiveTab}
        />
      )}
    </>
  );
};

export default UserHeader;
